// @generated by protobuf-ts 2.9.5 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/common/activity/v1/element.proto" (package "bianka.common.activity.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../../../google/protobuf/wrappers";
import { Int32Value } from "../../../../google/protobuf/wrappers";
import { ElementType } from "../../../enums/activity/element_type";
/**
 * Next serial number to be used: 7
 *
 * @generated from protobuf message bianka.common.activity.v1.Element
 */
export interface Element {
    /**
     * Element's name
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Element's type
     *
     * @generated from protobuf field: bianka.enums.activity.ElementType type = 2;
     */
    type: ElementType;
    /**
     * Element's position inside the parent element when the order matters
     *
     * @generated from protobuf field: google.protobuf.Int32Value position = 3;
     */
    position?: Int32Value;
    /**
     * Element's text value
     *
     * @generated from protobuf field: google.protobuf.StringValue text = 4;
     */
    text?: StringValue;
    /**
     * Number of elements in the element
     *
     * @generated from protobuf field: optional int32 number_of_elements = 6;
     */
    numberOfElements?: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class Element$Type extends MessageType<Element> {
    constructor() {
        super("bianka.common.activity.v1.Element", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "type", kind: "enum", T: () => ["bianka.enums.activity.ElementType", ElementType, "ELEMENT_TYPE_"] },
            { no: 3, name: "position", kind: "message", T: () => Int32Value },
            { no: 4, name: "text", kind: "message", T: () => StringValue },
            { no: 6, name: "number_of_elements", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message bianka.common.activity.v1.Element
 */
export const Element = new Element$Type();
